module.exports = __webpack_public_path__ + "static/media/moca-cares.b6344d72.png";